/**
 * Voyage ▸ Reports ▸ All Reports metinleri (ADR 0082; ortağın `sefer-6.jpeg`) ve Voyage menüsünün
 * yeni öğelerinin bilgi penceresi içerikleri (ADR 0053). Ekran adları İngilizce; Türkçe ikinci dil.
 */

export const allReportsEn = {
  title: 'All Reports',
  description:
    'All operational reports in chronological order. Reports can be created with or without a voyage assignment.',
  addNew: 'Add New Report',
  export: 'Export',
  filters: 'Report filters',
  vessel: 'Vessel',
  noVessel: 'No vessel',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  anyDate: 'Any date',
  reportType: 'Report Type',
  allTypes: 'All Types',
  voyage: 'Voyage',
  allVoyages: 'All',
  unassigned: 'Unassigned',
  location: 'Port / Location',
  allLocations: 'All',
  status: 'Status',
  allStatuses: 'All',
  reset: 'Reset',
  table: 'Reports table',
  columns: {
    no: '#',
    reportNo: 'Report No',
    date: 'Date / Time (UTC)',
    type: 'Report Type',
    location: 'Port / Location',
    voyage: 'Voyage',
    keyInfo: 'Key Information',
    status: 'Status',
    actions: 'Actions',
  },
  types: {
    arrival: 'Arrival Report',
    port_daily: 'Daily Port Report',
    departure: 'Departure Report',
    anchoring: 'Anchoring Report',
    anchor_aweigh: 'Anchor Aweigh Report',
    drifting: 'Drifting Report',
    drift_departure: 'Drift Departure Report',
    canal_strait: 'Canal / Strait Transit',
    noon: 'Noon Report',
    other: 'Other Events',
  },
  statuses: {
    draft: 'Draft',
    submitted: 'Submitted',
    amended: 'Amended',
    reopened: 'Reopened',
    void: 'Void',
  },
  locations: {
    sea: 'At Sea',
    seaAt: 'At Sea ({{position}})',
    anchorage: 'At Anchor',
    anchorageAt: 'At Anchor ({{position}})',
  },
  keys: {
    speed: 'Speed {{value}}',
    consumption: 'Cons. {{value}}',
    distance: 'Dist {{value}}',
    pilotOff: 'Pilot Off {{value}}',
    pilotOn: 'Pilot On {{value}}',
    allFast: 'All Fast {{value}}',
    noPilot: 'No pilot',
    loadCondition: '{{value}}',
    nextPort: 'Next: {{value}}',
    distanceToPort: 'To port {{value}}',
    norTendered: 'NOR {{value}}',
    activity: '{{value}}',
    cargoTotal: 'Cargo {{value}}',
    anchored: 'Anchored {{value}}',
    reason: '{{value}}',
    anchorAweigh: 'Anchor Aweigh {{value}}',
    nextOperation: 'Next: {{value}}',
    driftStart: 'Drift Start {{value}}',
    driftEnd: 'Drift End {{value}}',
    waitingStart: 'Waiting {{value}}',
    waitingEnd: 'Waiting End {{value}}',
    passage: '{{value}}',
    operation: '{{value}}',
    charterParty: 'CP {{value}}',
  },
  view: 'View {{no}}',
  viewTitle: 'View',
  edit: 'Edit {{no}}',
  editTitle: 'Edit',
  more: 'More actions for {{no}}',
  openLog: 'Open voyage log ({{no}})',
  openUnassigned: 'Open departures without voyage',
  emptyTitle: 'No reports yet',
  emptyShip:
    'Reports entered on board appear here in chronological order, with or without a voyage.',
  emptyWeb: 'Reports arrive from the vessel with synchronisation.',
  noMatch: 'No reports match the filters.',
  showing: 'Showing {{from}}–{{to}} of {{total}} reports',
  pagination: 'Report pages',
};

export const allReportsTr: typeof allReportsEn = {
  title: 'Tüm Raporlar',
  description:
    'Bütün operasyon raporları kronolojik sırayla. Raporlar seferle ya da sefersiz girilebilir.',
  addNew: 'Yeni Rapor',
  export: 'Dışa Aktar',
  filters: 'Rapor süzgeçleri',
  vessel: 'Gemi',
  noVessel: 'Gemi yok',
  dateFrom: 'Başlangıç',
  dateTo: 'Bitiş',
  anyDate: 'Her tarih',
  reportType: 'Rapor Türü',
  allTypes: 'Tüm Türler',
  voyage: 'Sefer',
  allVoyages: 'Tümü',
  unassigned: 'Sefersiz',
  location: 'Liman / Konum',
  allLocations: 'Tümü',
  status: 'Durum',
  allStatuses: 'Tümü',
  reset: 'Sıfırla',
  table: 'Rapor tablosu',
  columns: {
    no: '#',
    reportNo: 'Rapor No',
    date: 'Tarih / Saat (UTC)',
    type: 'Rapor Türü',
    location: 'Liman / Konum',
    voyage: 'Sefer',
    keyInfo: 'Temel Bilgi',
    status: 'Durum',
    actions: 'İşlemler',
  },
  types: {
    arrival: 'Varış Raporu',
    port_daily: 'Günlük Liman Raporu',
    departure: 'Kalkış Raporu',
    anchoring: 'Demirleme Raporu',
    anchor_aweigh: 'Demir Alma Raporu',
    drifting: 'Sürüklenme Raporu',
    drift_departure: 'Sürüklenme Bitiş Raporu',
    canal_strait: 'Kanal / Boğaz Geçişi',
    noon: 'Öğle Raporu',
    other: 'Diğer Olaylar',
  },
  statuses: {
    draft: 'Taslak',
    submitted: 'Gönderildi',
    amended: 'Düzeltildi',
    reopened: 'Yeniden açıldı',
    void: 'İptal',
  },
  locations: {
    sea: 'Denizde',
    seaAt: 'Denizde ({{position}})',
    anchorage: 'Demirde',
    anchorageAt: 'Demirde ({{position}})',
  },
  keys: {
    speed: 'Hız {{value}}',
    consumption: 'Tük. {{value}}',
    distance: 'Mes. {{value}}',
    pilotOff: 'Pilot ayrıldı {{value}}',
    pilotOn: 'Pilot bindi {{value}}',
    allFast: 'All Fast {{value}}',
    noPilot: 'Pilotsuz',
    loadCondition: '{{value}}',
    nextPort: 'Sonraki: {{value}}',
    distanceToPort: 'Limana {{value}}',
    norTendered: 'NOR {{value}}',
    activity: '{{value}}',
    cargoTotal: 'Yük {{value}}',
    anchored: 'Demirlendi {{value}}',
    reason: '{{value}}',
    anchorAweigh: 'Demir alındı {{value}}',
    nextOperation: 'Sonraki: {{value}}',
    driftStart: 'Sürüklenme {{value}}',
    driftEnd: 'Sürüklenme bitti {{value}}',
    waitingStart: 'Bekleme {{value}}',
    waitingEnd: 'Bekleme bitti {{value}}',
    passage: '{{value}}',
    operation: '{{value}}',
    charterParty: 'CP {{value}}',
  },
  view: '{{no}} görüntüle',
  viewTitle: 'Görüntüle',
  edit: '{{no}} düzenle',
  editTitle: 'Düzenle',
  more: '{{no}} için diğer işlemler',
  openLog: 'Sefer günlüğünü aç ({{no}})',
  openUnassigned: 'Sefersiz kalkışları aç',
  emptyTitle: 'Henüz rapor yok',
  emptyShip: 'Gemide girilen raporlar burada kronolojik sırayla görünür; seferli ya da sefersiz.',
  emptyWeb: 'Raporlar gemiden senkronla gelir.',
  noMatch: 'Süzgeçlere uyan rapor yok.',
  showing: '{{total}} rapordan {{from}}–{{to}} gösteriliyor',
  pagination: 'Rapor sayfaları',
};

interface HelpEntry {
  summary: string;
  steps: string[];
  tip?: string;
}

/** Rapor öğesinin içeriği: All Reports bu türün süzgeciyle açılır. */
function typeHelpEn(name: string, contains: string): HelpEntry {
  return {
    summary: `All Reports opened with the Report Type filter “${name}” (${contains}). It lists these reports of the vessel in chronological order, with or without a voyage.`,
    steps: [
      'Narrow the list with “Date From”, “Date To”, “Voyage” (“Unassigned” for reports without a voyage), “Port / Location” and “Status”; “Reset” clears the filters.',
      'Select the eye icon to open the report; on board, the pencil opens a draft or reopened report for editing.',
      `On board, “Add New Report” opens the ${name} form of the voyage flow.`,
      'Select “Export” to save the filtered list as a CSV file.',
    ],
  };
}

function typeHelpTr(name: string, contains: string): HelpEntry {
  return {
    summary: `“${name}” rapor türü süzgeciyle açılan Tüm Raporlar (${contains}). Geminin bu raporlarını kronolojik sırayla, seferli ya da sefersiz listeler.`,
    steps: [
      'Listeyi “Başlangıç”, “Bitiş”, “Sefer” (sefersiz raporlar için “Sefersiz”), “Liman / Konum” ve “Durum” ile daraltın; “Sıfırla” süzgeçleri temizler.',
      'Raporu açmak için göz simgesini seçin; gemide kalem, taslak ya da yeniden açılmış raporu düzenlemeye açar.',
      `Gemide “Yeni Rapor”, sefer akışının ${name} formunu açar.`,
      'Süzülmüş listeyi CSV dosyası olarak kaydetmek için “Dışa Aktar”ı seçin.',
    ],
  };
}

export const voyageReportsHelpEn: Record<string, HelpEntry> = {
  voyageReportsAll: {
    summary:
      'All operational reports of the vessel in chronological order, with or without a voyage: departure, noon, arrival, port daily, anchorage, drift, canal and strait reports and the other voyage events.',
    steps: [
      'In the office, choose the “Vessel” first.',
      'Filter by “Date From” and “Date To” (UTC), “Report Type”, “Voyage” (“Unassigned” shows departures entered without a voyage), “Port / Location” and “Status”; “Reset” clears them.',
      'Read “Key Information” for each report (e.g. speed, consumption and distance of a noon report, pilot and all fast times of an arrival); click a column heading to sort.',
      'Select the eye icon to open the report in its form; on board, the pencil opens a draft or reopened report; “…” opens the voyage log.',
      'On board, “Add New Report” opens the existing report forms; “Export” saves the filtered list as CSV.',
    ],
    tip: 'Leg / Event and the Noon Report form are opened from here; their old links still work.',
  },
  voyageReportsArrival: typeHelpEn('Arrival Report', 'EOSP and berthing reports'),
  voyageReportsDailyPort: typeHelpEn('Daily Port Report', 'daily reports at berth'),
  voyageReportsDeparture: typeHelpEn('Departure Report', 'departures, also without a voyage'),
  voyageReportsAnchoring: typeHelpEn('Anchoring Report', 'anchor dropped reports'),
  voyageReportsAnchorAweigh: typeHelpEn('Anchor Aweigh Report', 'anchor aweigh reports'),
  voyageReportsDrifting: typeHelpEn('Drifting Report', 'drift start reports'),
  voyageReportsDriftDeparture: typeHelpEn('Drift Departure Report', 'drift end reports'),
  voyageReportsCanalStrait: typeHelpEn(
    'Canal / Strait Transit',
    'strait and canal entry and exit reports',
  ),
  voyageReportsNoon: typeHelpEn('Noon Report', 'daily noon reports at sea'),
  voyageDetails: {
    summary:
      'The voyage record: voyage number, ports, status, start and end, and every report linked to the voyage in date order, with the events, legs, fuel consumption and voyage periods derived from them.',
    steps: [
      'Choose the voyage at the top right (in the office, the vessel first).',
      'Read “Linked Reports” in date order; the eye icon opens a report in its form.',
      '“Voyage Legs” lists the sea passages between port, anchorage and drift stays with distance and duration.',
      '“Events”, “Fuel Consumption” and “Voyage Periods” are derived from the submitted reports.',
      'Open the “Voyage Timeline” or “Voyage Summary” of the same voyage from the record card.',
    ],
    tip: 'Nothing is entered here: correct a report and the voyage record changes with it.',
  },
  voyageTimeline: {
    summary:
      'The voyage on a horizontal line: events above, sea, port, anchorage and drift periods in the middle, legs with distances and stays with durations below.',
    steps: [
      'Choose the voyage at the top right.',
      'Filter by “All Events”, “Reports”, “Port Operations”, “Anchorage / Drift” or “Voyage Legs”.',
      'Points close together are combined (“+2”); hover a point to see all of them.',
      '“Fit View” fits the whole voyage; turn it off to spread the days and scroll; the full screen button enlarges the chart (Esc closes).',
    ],
    tip: 'An ongoing voyage continues as a dashed line to the planned ETA.',
  },
  voyageSummary: {
    summary:
      'Sailing, port, anchorage, drift and waiting time, distance, sailing speed and consumption by fuel type, derived from the submitted reports.',
    steps: [
      'Choose the voyage at the top right.',
      'Read the figures and the time distribution; strait and canal time is part of sailing time.',
      '“Fuel Consumption by Period” splits each fuel into at sea, in port, at anchor, drifting and waiting.',
      '“Download PDF” saves the summary; a completed voyage is marked Final, an ongoing one Provisional.',
    ],
    tip: 'Only submitted reports are counted; a draft or reopened report is left out until it is submitted.',
  },
  voyageReportTemplates: {
    summary:
      'The fields of each voyage report type with their type and whether they are required, taken from the report forms.',
    steps: [
      'Choose the “Report Type”.',
      'Read each field with its type (time, number, selection, section, table) and requirement.',
      'The count above the table shows how many fields the report has and how many are required.',
    ],
    tip: 'Read only: the forms open from All Reports.',
  },
  voyageEventTypes: {
    summary:
      'The events recorded in the voyage reports (EOSP, COSP, Pilot On / Off, NOR, First Line, All Fast …) with the report and field each one comes from.',
    steps: [
      'Find the event and its category.',
      'See which report and which field give its time.',
      'Recent Events in All Reports, the Voyage Timeline and Voyage Details read this list.',
    ],
    tip: 'Events are not entered separately: they are the time fields of the reports.',
  },
  voyageFuelAnalysis: {
    summary:
      'Consumption by fuel type at sea, in port, at anchor, drifting and waiting, the daily average, consumption per mile, consumption by leg and period, and the ROB flow reconciled with bunkering. Derived from the submitted reports.',
    steps: [
      'Choose “Voyage” and the voyage, or “Period” and the dates (UTC).',
      'Read the key figures and “Consumption by Fuel”; the bar shows how each fuel splits by state.',
      '“Bunker Reconciliation” compares opening ROB + bunkered − closing ROB with the consumption written in the reports.',
      'In “ROB Flow” choose a fuel; “Only differences” lists the reports whose ROB is not what the previous ROB, consumption and bunkering give.',
    ],
    tip: 'A difference is a warning, not a correction: the report is reopened and corrected on board.',
  },
};

export const voyageReportsHelpTr: Record<string, HelpEntry> = {
  voyageReportsAll: {
    summary:
      'Geminin bütün operasyon raporları kronolojik sırayla, seferli ya da sefersiz: kalkış, öğle, varış, limanda günlük, demir, sürüklenme, kanal ve boğaz raporları ve diğer sefer olayları.',
    steps: [
      'Ofiste önce “Gemi”yi seçin.',
      '“Başlangıç” ve “Bitiş” (UTC), “Rapor Türü”, “Sefer” (“Sefersiz” seferi olmadan girilen kalkışları gösterir), “Liman / Konum” ve “Durum” ile süzün; “Sıfırla” temizler.',
      'Her raporun “Temel Bilgi”sini okuyun (ör. öğle raporunun hızı, tüketimi ve mesafesi, varışın pilot ve all fast saatleri); sıralamak için sütun başlığına tıklayın.',
      'Raporu formunda açmak için göz simgesini seçin; gemide kalem taslak ya da yeniden açılmış raporu açar; “…” sefer günlüğünü açar.',
      'Gemide “Yeni Rapor” mevcut rapor formlarını açar; “Dışa Aktar” süzülmüş listeyi CSV olarak kaydeder.',
    ],
    tip: 'Bacak / Olay ve Öğle Raporu formu buradan açılır; eski bağlantıları da çalışır.',
  },
  voyageReportsArrival: typeHelpTr('Varış Raporu', 'EOSP ve yanaşma raporları'),
  voyageReportsDailyPort: typeHelpTr('Günlük Liman Raporu', 'rıhtımda günlük raporlar'),
  voyageReportsDeparture: typeHelpTr('Kalkış Raporu', 'sefersiz olanlar dahil kalkışlar'),
  voyageReportsAnchoring: typeHelpTr('Demirleme Raporu', 'demir atma raporları'),
  voyageReportsAnchorAweigh: typeHelpTr('Demir Alma Raporu', 'demir alma raporları'),
  voyageReportsDrifting: typeHelpTr('Sürüklenme Raporu', 'sürüklenme başlangıcı raporları'),
  voyageReportsDriftDeparture: typeHelpTr('Sürüklenme Bitiş Raporu', 'sürüklenme bitişi raporları'),
  voyageReportsCanalStrait: typeHelpTr(
    'Kanal / Boğaz Geçişi',
    'boğaz ve kanal giriş ve çıkış raporları',
  ),
  voyageReportsNoon: typeHelpTr('Öğle Raporu', 'denizde günlük öğle raporları'),
  voyageDetails: {
    summary:
      'Sefer kaydı: sefer numarası, limanlar, durum, başlangıç ve bitiş; sefere bağlı her rapor tarih sırasıyla ve bunlardan türetilen olaylar, bacaklar, yakıt tüketimi ve sefer dönemleri.',
    steps: [
      'Sağ üstte seferi seçin (ofiste önce gemiyi).',
      '“Bağlı Raporlar”ı tarih sırasıyla okuyun; göz simgesi raporu formunda açar.',
      '“Sefer Bacakları” liman, demir ve sürüklenme kalışları arasındaki deniz seyirlerini mesafe ve süreyle listeler.',
      '“Olaylar”, “Yakıt Tüketimi” ve “Sefer Dönemleri” gönderilmiş raporlardan türetilir.',
      'Aynı seferin “Sefer Zaman Çizelgesi”ni ya da “Sefer Özeti”ni kayıt kartından açın.',
    ],
    tip: 'Burada hiçbir şey girilmez: rapor düzeltilince sefer kaydı da değişir.',
  },
  voyageTimeline: {
    summary:
      'Sefer yatay bir çizgide: üstte olaylar, ortada deniz, liman, demir ve sürüklenme dönemleri, altta mesafeleriyle bacaklar ve süreleriyle kalışlar.',
    steps: [
      'Sağ üstte seferi seçin.',
      '“Tüm Olaylar”, “Raporlar”, “Liman İşlemleri”, “Demir / Sürüklenme” ya da “Sefer Bacakları” ile süzün.',
      'Birbirine yakın noktalar birleşir (“+2”); hepsini görmek için noktanın üstüne gelin.',
      '“Sığdır” bütün seferi sığdırır; kapatınca günler açılır ve kaydırılır; tam ekran düğmesi çizelgeyi büyütür (Esc kapatır).',
    ],
    tip: 'Süren sefer planlanan ETA’ya kesikli çizgiyle devam eder.',
  },
  voyageSummary: {
    summary:
      'Gönderilmiş raporlardan türetilen seyir, liman, demir, sürüklenme ve bekleme süresi, mesafe, seyir hızı ve yakıt türüne göre tüketim.',
    steps: [
      'Sağ üstte seferi seçin.',
      'Değerleri ve süre dağılımını okuyun; boğaz ve kanal süresi seyir süresinin parçasıdır.',
      '“Döneme Göre Yakıt Tüketimi” her yakıtı denizde, limanda, demirde, sürüklenmede ve beklemede diye ayırır.',
      '“PDF İndir” özeti kaydeder; tamamlanan sefer Nihai, süren sefer Geçici işaretlidir.',
    ],
    tip: 'Yalnız gönderilmiş raporlar sayılır; taslak ya da yeniden açılmış rapor gönderilene dek girmez.',
  },
  voyageReportTemplates: {
    summary:
      'Her sefer rapor türünün alanları, türleri ve zorunlu olup olmadıkları; rapor formlarından alınır.',
    steps: [
      '“Rapor Türü”nü seçin.',
      'Her alanı türüyle (zaman, sayı, seçim, bölüm, tablo) ve zorunluluğuyla okuyun.',
      'Tablonun üstündeki sayı raporun kaç alanı olduğunu ve kaçının zorunlu olduğunu gösterir.',
    ],
    tip: 'Salt okunur: formlar Tüm Raporlar’dan açılır.',
  },
  voyageEventTypes: {
    summary:
      'Sefer raporlarında kaydedilen olaylar (EOSP, COSP, Pilot On / Off, NOR, İlk Halat, All Fast …) ve her birinin geldiği rapor ve alan.',
    steps: [
      'Olayı ve kategorisini bulun.',
      'Saatinin hangi rapordan ve hangi alandan geldiğini görün.',
      'Tüm Raporlar’daki Son Olaylar, Sefer Zaman Çizelgesi ve Sefer Ayrıntıları bu listeyi okur.',
    ],
    tip: 'Olaylar ayrıca girilmez: raporların zaman alanlarıdır.',
  },
  voyageFuelAnalysis: {
    summary:
      'Denizde, limanda, demirde, sürüklenmede ve beklemede yakıt türüne göre tüketim, günlük ortalama, mil başına tüketim, bacak ve dönem dökümü ve ikmalle mutabık ROB akışı. Gönderilmiş raporlardan türetilir.',
    steps: [
      '“Sefer” ve seferi ya da “Dönem” ve tarihleri (UTC) seçin.',
      'Temel değerleri ve “Yakıta Göre Tüketim”i okuyun; çubuk her yakıtın durumlara dağılımını gösterir.',
      '“İkmal Mutabakatı” açılış ROB + ikmal − kapanış ROB ile raporlarda yazılan tüketimi karşılaştırır.',
      '“ROB Akışı”nda yakıtı seçin; “Yalnız farklar” ROB’u önceki ROB, tüketim ve ikmalin verdiğiyle tutmayan raporları listeler.',
    ],
    tip: 'Fark bir uyarıdır, düzeltme değildir: rapor gemide yeniden açılıp düzeltilir.',
  },
};
